import { render, staticRenderFns } from "./ShiftsList.vue?vue&type=template&id=dc5b4a38&scoped=true&"
import script from "./ShiftsList.vue?vue&type=script&lang=js&"
export * from "./ShiftsList.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsList.vue?vue&type=style&index=0&id=dc5b4a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5b4a38",
  null
  
)

export default component.exports